<template>
  <v-btn depressed
  class="mx-2"
  :disabled="!isActivated"
  color="primary" @click="create">
    {{ text || $t('create') }}
    <v-icon right dark> mdi-plus-thick </v-icon>
  </v-btn>
</template>

<script>
import { activationStore } from "@/utils/helpers";
import { getUserRole } from "@/services/AuthService";

export default {
  name: "CreateButton",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup() {
    return { activationStore }
  },
  computed: {
    isActivated() {
      const role = getUserRole();
      if (role === 0 || role === 3 || role === 4 || role === 5) {
        return true;
      }
      return this.activationStore.isActivated;
    }
  },
  methods: {
    create() {
      this.$emit("create");
    }
  }
};
</script>
